import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinkurkumbhmidc() {



const cardData =
  {
    keyword: 'Bus On Rent In Kurkumbh MIDC',
    heading: 'Sanavi Travels: Bus On Rent In Kurkumbh MIDC',
    headingDescription: 'Sanavi Travels offers reliable and professional Bus On Rent In Kurkumbh MIDC, providing safe, spacious, and efficient transportation solutions for industrial staff, corporate employees, factory workers, management teams, and visiting professionals. Kurkumbh MIDC is one of the most active industrial hubs in Pune district, housing chemical plants, manufacturing units, warehouses, and corporate facilities that require punctual and organized employee transportation on a daily basis. To meet these requirements, we maintain a dedicated fleet of AC buses, Non-AC buses, mini buses, luxury coaches, and high-capacity buses designed for regular staff movement as well as corporate and industrial travel. Our buses are equipped with comfortable seating, proper ventilation, smooth suspension, and adequate standing and luggage space to support long working shifts and daily commuting. With experienced drivers familiar with industrial routes, shift timings, and safety protocols, flexible rental packages including daily employee transport, monthly contracts, and long-term corporate agreements, transparent pricing with no hidden charges, and 24/7 operational support, bus rental in Kurkumbh MIDC becomes dependable and stress-free. Choose Sanavi Travels for trusted industrial and corporate bus rental services in Kurkumbh MIDC, ensuring punctuality, safety, comfort, and seamless employee transportation every day.',

    top: 'Key Areas and Travel Points Around Kurkumbh MIDC with Sanavi Travels',


"topPlaces": [
  {
    "title": "Kurkumbh MIDC Industrial Area",
    "description": "Kurkumbh MIDC is a major industrial zone housing chemical industries, manufacturing plants, and corporate facilities. Bus rentals play a critical role in daily employee transportation, shift-wise movement, and management travel."
  },
  {
    "title": "Factory and Warehouse Zones",
    "description": "Multiple factories and warehouses within Kurkumbh MIDC require organized bus services for workers, supervisors, and visiting officials to maintain punctual operations."
  },
  {
    "title": "Residential Areas Near Kurkumbh",
    "description": "Nearby residential villages and towns supply a large workforce to Kurkumbh MIDC, making bus transport essential for safe and timely daily commuting."
  },
  {
    "title": "Daund and Surrounding Towns",
    "description": "Daund and nearby towns are closely connected to Kurkumbh MIDC, often serving as pickup points for employees and industrial staff."
  },
  {
    "title": "Pune City Connectivity",
    "description": "Kurkumbh MIDC is connected to Pune city via major highways, enabling corporate visits, inspections, and inter-office travel using hired buses."
  },
  {
    "title": "Logistics and Transport Routes",
    "description": "Industrial transport routes around Kurkumbh MIDC are heavily used by staff buses and company transport vehicles to maintain production schedules."
  },
  {
    "title": "Corporate Guest Houses",
    "description": "Guest houses and accommodation facilities near Kurkumbh MIDC often rely on bus rentals for transporting visiting executives and auditors."
  },
  {
    "title": "Training and Skill Centers",
    "description": "Training centers serving industrial staff use bus hire services for transporting trainees and employees safely and efficiently."
  },
  {
    "title": "Industrial Meetings and Conferences",
    "description": "Corporate meetings, audits, and conferences held in and around Kurkumbh MIDC frequently require organized group transportation."
  },
  {
    "title": "Outstation Industrial Travel",
    "description": "Companies in Kurkumbh MIDC often organize outstation travel for training, factory visits, and corporate events, making bus rentals essential."
  }
]
,



"services": [
{
"name": "Bus On Rent In Kurkumbh MIDC",
"description": "Bus On Rent In Kurkumbh MIDC provides reliable, spacious, and well-maintained buses specifically designed for industrial and corporate transportation needs. These buses are ideal for daily employee transport, management travel, factory staff movement, and visiting professionals. Each bus offers comfortable seating, proper ventilation, smooth suspension, and sufficient standing and luggage space to support long working hours and repeated daily trips. Professional drivers ensure disciplined driving, route familiarity, punctual pickups, and adherence to industrial safety standards."
},
{
"name": "Bus Hire Kurkumbh MIDC",
"description": "Bus Hire Kurkumbh MIDC offers flexible and dependable transportation solutions for industries, factories, and corporate offices. Whether for daily shifts, rotational staff movement, or special industrial events, this service ensures organized travel with reliable scheduling, professional coordination, and buses matched to workforce size and operational needs."
},
{
"name": "AC Bus Rental Kurkumbh MIDC",
"description": "AC Bus Rental Kurkumbh MIDC is ideal for managerial staff, corporate executives, and long-distance industrial travel. Fully air-conditioned interiors, comfortable seating, controlled airflow, and smooth ride quality help employees remain relaxed and productive, especially during long commutes and hot weather conditions."
},
{
"name": "Non AC Bus Hire Kurkumbh",
"description": "Non AC Bus Hire Kurkumbh provides economical transportation for factory workers, shift-based staff, and short-distance employee movement. These buses are robust, well-maintained, and suitable for high-frequency daily usage while maintaining safety and reliability."
},
{
"name": "Corporate Bus Hire Kurkumbh MIDC",
"description": "Corporate Bus Hire Kurkumbh MIDC supports professional employee transportation for offices, plants, and corporate facilities. This service focuses on punctuality, disciplined operations, fixed routes, and contract-based arrangements to ensure seamless daily commuting for staff and executives."
},
{
"name": "Industrial Bus Rental Kurkumbh MIDC",
"description": "Industrial Bus Rental Kurkumbh MIDC is designed specifically for manufacturing units, chemical plants, and industrial companies requiring reliable workforce movement. These buses support shift-wise transport, emergency movement, audits, and factory coordination with strict adherence to timing and safety norms."
},
{
"name": "Employee Transportation Kurkumbh",
"description": "Employee Transportation Kurkumbh offers structured and contract-based transport solutions for daily workforce commuting. With fixed pickup points, optimized routes, and experienced drivers, this service ensures employees reach workplaces safely, on time, and without stress."
},
{
"name": "32 Seater Bus on Rent Kurkumbh",
"description": "32 Seater Bus on Rent Kurkumbh is suitable for medium-sized staff groups, supervisors, and team movements. These buses balance capacity and comfort, making them ideal for daily employee transport and inter-departmental travel."
},
{
"name": "35 Seater Bus Hire Kurkumbh",
"description": "35 Seater Bus Hire Kurkumbh supports larger workforce groups and shift-based transportation. With spacious seating and reliable performance, these buses ensure efficient and organized employee movement."
},
{
"name": "Bus on Rent Kurkumbh for Factory Staff",
"description": "Bus on Rent Kurkumbh for Factory Staff provides safe, disciplined, and reliable transport for workers across different shifts. These buses are designed for daily operational use, ensuring smooth factory attendance and reduced absenteeism."
},
{
"name": "Bus Rental Kurkumbh for Companies",
"description": "Bus Rental Kurkumbh for Companies offers long-term and short-term transportation contracts for industrial units and corporate offices. This service supports workforce mobility, management travel, and operational coordination with transparent pricing."
},
{
"name": "Bus Hire Kurkumbh MIDC with Driver",
"description": "Bus Hire Kurkumbh MIDC with Driver provides chauffeur-driven buses where trained drivers manage industrial routes, traffic, and safety compliance, allowing companies to focus on core operations."
},
{
"name": "Affordable Bus Rental Kurkumbh",
"description": "Affordable Bus Rental Kurkumbh provides cost-effective industrial transport solutions for companies seeking budget-friendly employee transportation without compromising safety, cleanliness, or reliability."
},
{
"name": "Best Bus Service Kurkumbh MIDC",
"description": "Best Bus Service Kurkumbh MIDC is trusted by industries for disciplined operations, clean buses, professional drivers, transparent pricing, and consistent service quality, making Sanavi Travels a preferred industrial transport partner."
}
],
"tableData": [
["Bus On Rent In Kurkumbh MIDC", "Bus Hire Kurkumbh MIDC"],
["AC Bus Rental Kurkumbh MIDC", "Non AC Bus Hire Kurkumbh"],
["Corporate Bus Hire Kurkumbh MIDC", "Industrial Bus Rental Kurkumbh MIDC"],
["Employee Transportation Kurkumbh", "32 Seater Bus on Rent Kurkumbh"],
["35 Seater Bus Hire Kurkumbh", "Factory Staff Bus Kurkumbh"],
["Company Bus Rental Kurkumbh", "Bus Hire Kurkumbh with Driver"],
["Affordable Bus Rental Kurkumbh", "Best Bus Service Kurkumbh MIDC"],
["—", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent In Kurkumbh MIDC with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels is a trusted industrial transport provider offering reliable bus rental services in Kurkumbh MIDC for factories, companies, and corporate offices."
  },
  {
    "WhyChooseheading": "Industrial-Focused Fleet",
    "WhyChoosedescription": "Our buses are specifically selected and maintained to handle daily industrial employee transportation and shift-based operations."
  },
  {
    "WhyChooseheading": "Experienced Industrial Drivers",
    "WhyChoosedescription": "Our drivers are trained for industrial routes, shift timings, and safety compliance, ensuring smooth daily operations."
  },
  {
    "WhyChooseheading": "Transparent Contract Pricing",
    "WhyChoosedescription": "We offer clear pricing for daily, monthly, and long-term contracts with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Operational Support",
    "WhyChoosedescription": "Our support team is available round the clock to manage shifts, emergencies, and schedule changes."
  },
  {
    "WhyChooseheading": "Flexible Transport Solutions",
    "WhyChoosedescription": "We provide customized transport plans based on workforce size, shift patterns, and company requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are cleaned and sanitized regularly to maintain a hygienic travel environment for employees."
  },
  {
    "WhyChooseheading": "Reliable and Punctual Service",
    "WhyChoosedescription": "We ensure disciplined operations, on-time pickups, and consistent service quality for uninterrupted industrial workflow."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Kurkumbh MIDC?',
    answer: 'Yes, Sanavi Travels offers dedicated bus rental services in Kurkumbh MIDC for industrial and corporate transportation.'
  },
  {
    question: 'Do you provide employee transportation contracts in Kurkumbh?',
    answer: 'Yes, we offer daily, monthly, and long-term employee transportation contracts for companies in Kurkumbh MIDC.'
  },
  {
    question: 'What types of buses are available in Kurkumbh MIDC?',
    answer: 'We provide AC buses, Non-AC buses, 32-seater buses, 35-seater buses, and industrial staff buses.'
  },
  {
    question: 'Are drivers familiar with industrial shift timings?',
    answer: 'Yes, our drivers are trained and experienced in handling industrial routes and shift-based transport.'
  },
  {
    question: 'Is bus hire available for factory staff?',
    answer: 'Yes, we specialize in factory staff and employee transportation services.'
  },
  {
    question: 'Are buses sanitized regularly?',
    answer: 'Yes, all buses are cleaned and sanitized on a regular basis.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, bank transfers, corporate billing, and contract-based payments.'
  },
  {
    question: 'Is customer support available for emergencies?',
    answer: 'Yes, our 24/7 support team handles operational and emergency requirements.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil More',
    feedback: 'We use Sanavi Travels buses daily for employee transport in Kurkumbh MIDC. Very punctual and reliable service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Pooja Kulkarni',
    feedback: 'Excellent industrial bus service for our factory staff. Clean buses and disciplined drivers.',
    rating: 5
  }
];












  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Rent in Kurkumbh MIDC - Sanavi Travels",
  "description": "Sanavi Travels offers bus on rent in Kurkumbh MIDC for corporate, industrial, and employee transportation needs. We provide AC and Non-AC buses, 32 seater and 35 seater buses for factory staff, companies, and outstation travel with trained drivers at affordable prices.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "190"
  }
};








  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus on Rent in Kurkumbh MIDC | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Kurkumbh MIDC with Sanavi Travels for corporate, industrial, and employee transportation. AC & Non-AC buses with driver for factories and companies at best rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/216.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinkurkumbhmidc;